<div class="user_notificaction_container boxShadow">
    <div class="user_notification_title">
        <div class='row'>
            <div class='text-left col-lg-10 col-md-10 col-xl-10 col-sm-12 col-12'>
                <h3>Notificaciones</h3>
            </div>
        </div>
    </div>
    <div class='user_notificaction_body'>
        <div class='row'>
            <div class='col-12'><h3 class='ml-3 text-left'>Nuevas</h3></div>
            <div class='item' *ngFor="let i of notifications" (click)='showNotification(i);'>
                <div class='col-12'>
                    <h3>{{i.title}}</h3>
                </div>
                <div class='col-12'>
                    <h5 [innerHTML]="i.message"></h5>
                </div>
            </div>
        </div>
    </div>
    <div class='user_notification_footer mb-4 mt-4'>
        <div class='row'>
            <div class='col-12' (click)='markAllRead()'>
                <i class='fas fa-check'></i> Marcar todas como leidas
            </div>
        </div>
    </div>
</div>